<template>
  <el-form
    ref="form"
    v-loading="loading"
    class="app-form"
    :model="form"
    :rules="rules"
    label-width="250px"
  >
    <FormItem :scheme="scheme" :form="form" :is-edit="isEdit" />
    <el-form-item>
      <el-button type="primary" @click="onSubmit('form')">{{
        buttonNameSubmit ? buttonNameSubmit : isEdit ? `Изменить` : `Создать`
      }}</el-button>
      <!-- <el-button type="secondary" @click="init">Сбросить изменения</el-button> -->
      <el-button v-if="methodDeleteData" type="danger" @click="onDelete"
        >Удалить</el-button
      >
    </el-form-item>

    <!-- <div v-if="envDev">
        <b>current form</b>
        <p>{{ form }}</p>
        <hr>
        <b>server data</b>
        <p>{{ existData }}</p>
      </div> -->
  </el-form>
</template>

<script>
import FormItem from "@/components/FormItem";
import { messages } from "@/utils/validate";
import { mapGetters } from "vuex";

export default {
  name: "Form",
  components: {
    FormItem,
  },
  props: {
    scheme: {
      type: Object,
      default() {
        return {};
      },
    },
    methodFetchData: {
      type: Function,
      default: null,
    },
    methodCreateData: {
      type: Function,
      default: null,
    },
    /**
     * Отправляем только измененные поля(PATCH)
     */
    methodUpdateData: {
      type: Function,
      default: null,
    },
    /**
     * Отправляем все поля, а не только измененные(PUT)
     */
    methodUpdateDataIdempotent: {
      type: Function,
      default: null,
    },
    methodDeleteData: {
      type: Function,
      default: null,
    },
    methodUpdateScheme: {
      type: Function,
      default: null,
    },
    additionalValidationRules: {
      type: Object,
      default() {
        return {};
      },
    },
    isFormData: {
      type: Boolean,
      default: false,
    },
    isEditSettings: {
      type: Boolean,
      default: false,
    },
    isConfig: {
      type: Boolean,
      default: false,
    },
    buttonNameSubmit: {
      type: String,
      default: null,
    },
    messageAfterSubmit: {
      type: String,
      default: null,
    },
    sendAllForm: {
      type: Boolean,
      default: false,
    },
    createRegion: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: true,
      id: null,
      isEdit: this.isEditSettings || false,
      form: {},
      existData: {},
      rules: {},
      envDev: process.env.NODE_ENV === "development",
    };
  },
  created() {
    const { id } = this.$route.params;
    const { onlyEdit } = this.$route.meta;

    if (id) {
      this.id = id;
      this.isEdit = true;
    }

    if (onlyEdit) {
      this.isEdit = true;
      this.id = this.$route.params;
    }

    this.init();
  },
  computed: {
    ...mapGetters(["region"]),
  },
  methods: {
    async init() {
      this.loading = true;
      this.rules = this.getValidateRules();
      this.addAdditionalValidationRules();

      if (typeof this.methodUpdateScheme === "function") {
        this.scheme = await this.methodUpdateScheme(this.scheme);
      }

      this.form = this.getDefaultFormByScheme();

      if (this.isEdit) {
        this.existData = await this.fetchData(this.id);
        this.form = JSON.parse(JSON.stringify(this.existData));
        if (this.scheme.properties.contentOptions)
          this.form.contentOptions =
            this.scheme.properties.contentOptions.value;
      }

      this.loading = false;

      this.$nextTick(() => {
        if (this.$refs["form"]) this.$refs["form"].clearValidate();
      });
    },
    getDefaultFormByScheme() {
      const form = {};
      const { properties } = this.scheme;
      for (const key in properties) {
        const { title, value } = properties[key];

        form[key] = value;

        if (title === "Регион") form[key] = this.region;
      }
      return form;
    },
    async fetchData(id) {
      return await this.methodFetchData(id, this.$route.params);
    },
    /**
     * Проверяем есть ли правило required в схеме
     */
    isRequired(name) {
      const { required } = this.scheme;

      if (required) {
        return required.includes(name);
      }
      return false;
    },
    /**
     * Получаем правила валидации для поля
     */
    getRulesItem(name, item) {
      const rules = [];
      const { maxLength } = item;
      const isRequired = this.isRequired(name);

      if (isRequired) {
        rules.push({
          required: true,
          message: messages.required,
          trigger: ["blur", "change"],
        });
      }

      if (maxLength) {
        rules.push({
          max: maxLength,
          message: messages.maxLength + maxLength,
          trigger: ["blur", "change"],
        });
      }

      return rules;
    },
    /**
     * Получаем правила валидации из схемы.
     * (Предварительная валидация на фронте)
     */
    getValidateRules() {
      const rules = {};
      for (const name in this.scheme.properties) {
        const item = this.scheme.properties[name];

        rules[name] = this.getRulesItem(name, item);
      }

      return rules;
    },
    /**
     * Добавляем кастомные правила валидации прописанные в форме
     * в правила полученные из схемы
     */
    addAdditionalValidationRules() {
      for (const key in this.additionalValidationRules) {
        if (Object.hasOwnProperty.call(this.additionalValidationRules, key)) {
          const arrRules = this.rules[key];
          const newRule = this.additionalValidationRules[key].call(this);

          if (Array.isArray(arrRules)) {
            arrRules.push(newRule);
          }
        }
      }
    },
    /**
     * Показываем ошибки полученные от сервера
     */
    showErrorOnFields(data) {
      const { detail } = data;

      if (!Array.isArray(detail)) return;

      detail.forEach((item) => {
        const { loc, msg } = item;
        const name = loc[loc.length - 1];

        this.rules[name] = {
          required: true,
          message: msg,
          trigger: ["blur", "change"],
        };
      });

      this.$refs["form"].validate(() => {});
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    formattedForm() {
      const form = {};
      if (this.isEdit) {
        const form = {};

        for (const field in this.form) {
          if (
            JSON.stringify(this.existData[field]) !==
            JSON.stringify(this.form[field])
          ) {
            if (!this.scheme.properties[field].exclude)
              form[field] = this.form[field];
          } else {
            if (this.isConfig) {
              form[field] = this.form[field];
            }
          }
        }

        return form;
      }

      for (const field in this.form) {
        if (
          this.scheme.properties[field].default !== undefined &&
          this.form[field] === undefined
        ) {
          form[field] = this.scheme.properties[field].default;
        } else {
          if (!this.scheme.properties[field].exclude)
            form[field] = this.form[field];
        }
      }

      return form;
    },
    formContainFile(form) {
      let state = false;

      Object.keys(form).forEach((key) => {
        if (form[key] instanceof File) {
          state = true;
        }
      });
      return state;
    },
    createFormData(form) {
      const formData = new FormData();

      Object.keys(form).forEach((key) => {
        if (this.form[key] !== undefined) {
          formData.append(key, this.form[key]);
        }
      });

      return formData;
    },
    isNotChanged(dataForm) {
      if (Object.keys(dataForm).length) {
        return false;
      }
      return true;
    },
    async requestUpdate(form) {
      if (this.methodUpdateDataIdempotent) {
        return await this.methodUpdateDataIdempotent(
          this.id,
          {
            ...this.existData,
            ...form,
          },
          this.$route.params
        );
      }
      return await this.methodUpdateData(this.id, form, this.$route.params);
    },
    async updateData(form) {
      const data = await this.requestUpdate(form);

      this.existData = data;
      this.form = JSON.parse(JSON.stringify(this.existData));
      // this.fetchData(this.id)
      this.loading = false;
    },
    async createData(form) {
      const answer = await this.methodCreateData(form, this.$route.params);
      if (answer && "token" in answer && Object.keys(answer).length === 1) {
        this.$store.dispatch("polling/setPollingToken", answer.token);
      }
      // const redirect = this.$route.path.split("/").slice(1, -1).join("/");
      // this.$router.push(`/${redirect}`);
      return answer;
    },
    onSubmit(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (!valid) return;

        let sendForm = this.formattedForm();

        if (this.isNotChanged(sendForm)) {
          this.$message({
            type: "info",
            message: "Нет изменений.",
          });
          return;
        }

        if (this.formContainFile(sendForm) || this.isFormData) {
          sendForm = this.createFormData(sendForm);
        }

        try {
          this.loading = true;

          if (this.isEdit) {
            // для отправки всей формы вместе с данными, которые не были изменены
            if (this.sendAllForm) {
              await this.updateData(this.form);
            } else {
              // а тут только измененные
              await this.updateData(sendForm);
            }
          } else await this.createData(sendForm);

          this.init();

          this.$message({
            type: "success",
            message: this.messageAfterSubmit
              ? this.messageAfterSubmit
              : this.isEdit
              ? "Изменения сохранены."
              : "Запись создана.",
          });
        } catch (err) {
          console.log(err);
          this.loading = false;
          this.showErrorOnFields(err);
        }
      });
    },
    async onDelete() {
      await this.methodDeleteData(this.$route.params.id);
      this.$router.push("/freebase/products/list");
    },
  },
};
</script>
